export const DEFAULT_LAT = 48.8566;
export const DEFAULT_LNG = 2.3522;
export const DEFAULT_ZOOM = 12;

export function parseCoord(v: string | null, min: number, max: number): number | null {
  if (!v) return null;
  const n = parseFloat(v);
  return !isNaN(n) && n >= min && n <= max ? n : null;
}
